import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Empty from '../Empty';
import CarsMenu from '../carsMenu';
import CarsActive from '../carsActive';
import './styles.scss';

class Cars extends Component {
  constructor () {
    super();
    this.state = {
    };
  }
  showActiveMenuCars = () => {
    switch (this.props.pageControl.subMenu) {
      case 'active': return (
        <CarsActive />
      );
      case 'orders': return (
        <Empty />
      );
      case 'inLeasing': return (
        <Empty />
      );
      default: return (
        <CarsActive />
      );
    }
  }
  render() {
    return (
      <div className="body-cars">
        <div
          className="menu-cars"
          style={this.props.scrollLeft > 1 ? { left: `-${this.props.scrollLeft}px` } : { }}
        >
          <CarsMenu
            pageControl={this.props.pageControl}
            setSubMenu={this.props.setSubMenu}
          />
        </div>
        <div className="Activetable-cars">
          {
           this.showActiveMenuCars()
          }
        </div>
      </div>
    );
  }
}

Cars.propTypes = {
  setSubMenu: PropTypes.func.isRequired,
  pageControl: PropTypes.instanceOf(Object).isRequired,
  scrollLeft: PropTypes.number.isRequired
};

export default Cars;



// WEBPACK FOOTER //
// ./src/pages/CarEditorPage/components/cars/index.js